/* ===== BMTrade theme JS ===== */
(function () {
  'use strict';
  var money = function (cents) {
    return '£' + (cents / 100).toFixed(2);
  };

  /* ---------- mobile nav ---------- */
  var burger = document.getElementById('navBurger');
  var links = document.getElementById('navLinks');
  var backdrop = document.getElementById('navBackdrop');
  function closeNav() {
    if (!links) return;
    links.classList.remove('open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (backdrop) backdrop.classList.remove('open');
  }
  if (burger && links) {
    burger.addEventListener('click', function () {
      var open = links.classList.toggle('open');
      burger.setAttribute('aria-expanded', open);
      if (backdrop) backdrop.classList.toggle('open', open);
    });
    links.addEventListener('click', function (e) { if (e.target.tagName === 'A') closeNav(); });
  }
  if (backdrop) backdrop.addEventListener('click', closeNav);

  /* ---------- header search ---------- */
  var searchBtn = document.getElementById('navSearchBtn');
  var searchPanel = document.getElementById('navSearch');
  if (searchBtn && searchPanel) {
    searchBtn.addEventListener('click', function () {
      var open = searchPanel.hidden;
      searchPanel.hidden = !open;
      searchBtn.setAttribute('aria-expanded', open);
      if (open) {
        var input = document.getElementById('navSearchInput');
        if (input) input.focus();
      }
    });
    /* Escape closes it and returns focus to the trigger, so keyboard users are not
       stranded inside a panel they cannot dismiss. */
    searchPanel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { searchPanel.hidden = true; searchBtn.setAttribute('aria-expanded', 'false'); searchBtn.focus(); }
    });
  }

  /* ---------- nav dropdown toggles (mobile tap to expand) ---------- */
  document.querySelectorAll('.nav-links .dd-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      var item = toggle.closest('.nav-item');
      var open = item.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open);
    });
  });

  /* ---------- hero swatch cycle ---------- */
  var sw = document.getElementById('heroSwatch');
  if (sw && sw.dataset.cycle === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var colors = ['#F4419F', '#F5B450', '#79CC52', '#8A63E8', '#2F55A4', '#E2382A'];
    var i = 0;
    setInterval(function () { i = (i + 1) % colors.length; sw.style.background = colors[i]; }, 2200);
  }

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- cart count refresh ---------- */
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
  }

  /* sellingPlan is optional: when present the line is added as a subscription rather
     than a one-off. Shopify rejects a blank selling_plan, so it is only ever sent when
     the shopper has actually chosen a plan. */
  function addVariant(id, qty, btn, sellingPlan) {
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; }
    var payload = { id: id, quantity: qty || 1 };
    if (sellingPlan) payload.selling_plan = sellingPlan;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      refreshCart();
      if (btn) {
        btn.textContent = '✓ Added';
        btn.classList.add('added');
        setTimeout(function () { btn.textContent = original; btn.classList.remove('added'); btn.disabled = false; }, 1200);
      }
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = original; }
      window.location.href = '/cart';
    });
  }

  /* ---------- product card interactions (delegated) ---------- */
  document.addEventListener('click', function (e) {
    /* size / variant chips on cards */
    var sizeBtn = e.target.closest('.product .sizes button');
    if (sizeBtn && !sizeBtn.disabled) {
      var card = sizeBtn.closest('.product');
      card.querySelectorAll('.sizes button').forEach(function (b) { b.classList.remove('on'); });
      sizeBtn.classList.add('on');
      card.dataset.selected = sizeBtn.dataset.variantId;
      var priceEl = card.querySelector('[data-price]');
      if (priceEl && sizeBtn.dataset.price) priceEl.textContent = money(parseInt(sizeBtn.dataset.price, 10));
      var addBtn = card.querySelector('[data-add]');
      if (addBtn) { addBtn.disabled = sizeBtn.dataset.available === 'false'; }
      return;
    }
    /* fav toggle */
    var fav = e.target.closest('.product .fav');
    if (fav) {
      fav.classList.toggle('on');
      fav.textContent = fav.classList.contains('on') ? '♥' : '♡';
      return;
    }
    /* add to cart from card */
    var add = e.target.closest('.product [data-add]');
    if (add && !add.disabled) {
      var pcard = add.closest('.product');
      var vid = pcard.dataset.selected || add.dataset.variantId;
      if (vid) { e.preventDefault(); addVariant(vid, 1, add); }
      return;
    }
  });

  /* ---------- PDP: gallery + variant selection + add ---------- */
  var pdp = document.querySelector('[data-product-json]');
  if (pdp) {
    var productData = {};
    try { productData = JSON.parse(pdp.textContent); } catch (err) { productData = { variants: [] }; }

    var form = document.getElementById('pdpForm');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceNow = document.getElementById('pdpPriceNow');
    var priceWas = document.getElementById('pdpPriceWas');
    var addBtn = document.getElementById('pdpAdd');
    var planPicker = document.getElementById('pdpPlanPicker');
    var planSelect = document.getElementById('pdpPlan');
    var subRadio = document.getElementById('buy-sub');
    var unitEl = document.getElementById('pdpUnitPrice');
    var stickyBar = document.getElementById('pdpSticky');
    var stickyPrice = document.getElementById('pdpStickyPrice');
    var stickyAdd = document.getElementById('pdpStickyAdd');

    function subscribing() { return !!(subRadio && subRadio.checked); }
    function chosenPlan() { return subscribing() && planSelect ? planSelect.value : ''; }

    /* The allocation carries the real subscription price for this variant+plan pair, so
       the displayed price always matches what Shopify will charge. */
    function allocationFor(v) {
      var planId = chosenPlan();
      if (!planId || !v || !v.selling_plan_allocations) return null;
      for (var i = 0; i < v.selling_plan_allocations.length; i++) {
        if (String(v.selling_plan_allocations[i].selling_plan_id) === String(planId)) {
          return v.selling_plan_allocations[i];
        }
      }
      return null;
    }

    /* Pack weight comes from the variant's own option text, never variant.weight: the
       shipping weights in this shop are unreliable (every chicken-feet pack is recorded
       as 1000g, rabbit ears as 0g) and would produce nonsense per-kg figures. Anything
       that is not a weight -- piece counts like "10" or "25" -- returns null and simply
       gets no per-unit line. */
    function packKg(v) {
      if (!v) return null;
      var text = String(v.title || v.options.join(' '));
      var kg = text.match(/([\d.]+)\s*kg\b/i);
      if (kg) return parseFloat(kg[1]);
      var g = text.match(/([\d.]+)\s*g\b/i);
      if (g) return parseFloat(g[1]) / 1000;
      return null;
    }

    /* Baseline is the dearest per-kg variant (normally the smallest bag), which is what
       makes "save 8%" on the bigger bags meaningful. */
    var perKgBaseline = null;
    (function () {
      var worst = null;
      (productData.variants || []).forEach(function (v) {
        var kg = packKg(v);
        if (!kg) return;
        var rate = v.price / kg;
        if (worst === null || rate > worst) worst = rate;
      });
      perKgBaseline = worst;
    })();

    function updateUnitPrice(v) {
      if (!unitEl) return;
      var kg = packKg(v);
      if (!kg || !v) { unitEl.hidden = true; return; }
      var alloc = allocationFor(v);
      var price = alloc ? alloc.price : v.price;
      var txt = money(Math.round(price / kg)) + ' per kg';
      if (perKgBaseline) {
        var pct = Math.round((1 - (price / kg) / perKgBaseline) * 100);
        if (pct >= 1) txt += ' · save ' + pct + '% vs the smallest bag';
      }
      unitEl.textContent = txt;
      unitEl.hidden = false;
    }

    /* Per-kg hint on each size chip, so the cheaper bag is obvious before clicking. */
    function decorateChips() {
      if (!perKgBaseline) return;
      form.querySelectorAll('.opt-values input[type="radio"][data-option-index]').forEach(function (input) {
        var label = form.querySelector('label.chip[for="' + input.id + '"]');
        var slot = label ? label.querySelector('[data-chip-unit]') : null;
        if (!slot) return;
        var match = (productData.variants || []).find(function (v) {
          return v.options.indexOf(input.value) !== -1;
        });
        var kg = packKg(match);
        if (!kg) { slot.textContent = ''; return; }
        var pct = Math.round((1 - (match.price / kg) / perKgBaseline) * 100);
        slot.textContent = pct >= 1 ? 'save ' + pct + '%' : '';
      });
    }

    function currentOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (input) {
        if (input.type === 'radio') { if (input.checked) opts[input.dataset.optionIndex] = input.value; }
        else opts[input.dataset.optionIndex] = input.value;
      });
      return opts;
    }
    function findVariant(opts) {
      /* A product with a single default variant renders no option pickers, so there is nothing
         to match against: use the variant the form already carries. Matching [] against
         ["Default Title"] found nothing and disabled Add to basket on every one-size product. */
      if (!form.querySelector('[data-option-index]')) {
        var current = idInput ? Number(idInput.value) : 0;
        return productData.variants.find(function (v) { return v.id === current; }) || productData.variants[0];
      }
      return productData.variants.find(function (v) {
        return v.options.every(function (o, idx) { return o === opts[idx]; });
      });
    }
    var expressWrap = document.querySelector('[data-express-wrap]');
    function updateVariant() {
      var v = findVariant(currentOptions());
      if (planPicker) planPicker.hidden = !subscribing();
      /* A wallet button posts the plain variant and would silently drop the selling plan
         the shopper just picked, so express checkout is hidden while subscribing. */
      if (expressWrap) expressWrap.hidden = subscribing();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;

      var alloc = allocationFor(v);
      var shown = alloc ? alloc.price : v.price;
      /* When subscribing, the one-off price becomes the struck-through comparison so the
         saving is visible; otherwise fall back to the variant's own compare-at price. */
      var wasValue = alloc ? v.price : (v.compare_at_price > v.price ? v.compare_at_price : 0);

      if (priceNow) priceNow.textContent = money(shown);
      if (priceWas) {
        if (wasValue) { priceWas.textContent = money(wasValue); priceWas.style.display = ''; }
        else { priceWas.style.display = 'none'; }
      }
      if (stickyPrice) stickyPrice.textContent = money(shown);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (subscribing() ? 'Subscribe' : 'Add to basket') : 'Sold out';
      }
      if (stickyAdd) {
        stickyAdd.disabled = !v.available;
        stickyAdd.textContent = v.available ? (subscribing() ? 'Subscribe' : 'Add to basket') : 'Sold out';
      }
      updateUnitPrice(v);
    }
    if (form) {
      form.addEventListener('change', updateVariant);
      if (planSelect) planSelect.addEventListener('change', updateVariant);
      decorateChips();
      updateVariant();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (idInput && idInput.value) {
          addVariant(idInput.value, parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10), addBtn, chosenPlan());
        }
      });
    }

    /* Sticky bar proxies the real form so there is one add path, not two. */
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        addVariant(idInput.value, parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10), stickyAdd, chosenPlan());
      });
    }
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        stickyBar.hidden = entries[0].isIntersecting;
      }, { threshold: 0 });
      sio.observe(addBtn);
    }

    /* qty steppers */
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });

    /* gallery thumbs */
    var mainImg = document.getElementById('pdpMainImg');
    document.querySelectorAll('.pdp-thumbs button').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg && t.dataset.src) mainImg.src = t.dataset.src;
        document.querySelectorAll('.pdp-thumbs button').forEach(function (b) { b.classList.remove('on'); });
        t.classList.add('on');
      });
    });
  }

  /* ---------- reviews: reveal the full list ---------- */
  document.querySelectorAll('[data-pr-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var list = btn.parentNode.querySelector('[data-pr-list]');
      if (list) list.querySelectorAll('.pr-hidden').forEach(function (li) { li.classList.remove('pr-hidden'); });
      btn.remove();
    });
  });

  /* ---------- all-reviews page: reveal in batches ---------- */
  /* Batched rather than all at once: the list runs to hundreds of entries and dropping
     them in together causes a visible jank on a phone. */
  document.querySelectorAll('[data-ar-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var hidden = document.querySelectorAll('.ar-item.ar-hidden');
      for (var i = 0; i < 20 && i < hidden.length; i++) hidden[i].classList.remove('ar-hidden');
      if (document.querySelectorAll('.ar-item.ar-hidden').length === 0) btn.remove();
    });
  });

  /* ---------- mobile "show more" for the cut-down homepage grids ---------- */
  /* The cut-off is CSS (nth-child, scoped per section), so revealing the rest is just a
     class on the grid. Nothing is lazy-loaded: every card is already in the HTML, which
     keeps it all in the markup Google sees. */
  document.querySelectorAll('[data-pc-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = document.getElementById(btn.dataset.pcMore);
      if (grid) grid.classList.add('pc-open');
      var wrap = btn.closest('.pc-more-wrap');
      if (wrap) wrap.remove(); else btn.remove();
    });
  });

  /* ---------- homepage protein filters ---------- */
  var filterWrap = document.querySelector('[data-filters]');
  if (filterWrap) {
    filterWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.filter');
      if (!btn) return;
      filterWrap.querySelectorAll('.filter').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var isAll = btn.dataset.cat === 'all';
      var terms = (btn.dataset.terms || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var gridId = filterWrap.dataset.filters;
      var grid = document.getElementById(gridId);
      if (!grid) return;
      /* Picking a category means "show me every one of these", so drop the mobile
         cut-off and retire its button. Without this the nth-child rule would keep
         hiding cards by DOM position and fight the filter. */
      grid.classList.add('pc-open');
      var moreBtn = document.querySelector('[data-pc-more="' + gridId + '"]');
      if (moreBtn) {
        var moreWrap = moreBtn.closest('.pc-more-wrap');
        if (moreWrap) moreWrap.remove(); else moreBtn.remove();
      }
      grid.querySelectorAll('.product').forEach(function (card) {
        var key = (card.dataset.filter || card.dataset.type || '').toLowerCase();
        var show = isAll || terms.some(function (t) { return t && key.indexOf(t) !== -1; });
        card.style.display = show ? '' : 'none';
      });
    });
  }

  /* ---------- cart page qty updates ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.dataset.cartQty;
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () { window.location.reload(); });
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(btn.dataset.cartRemove, 10), quantity: 0 })
      }).then(function (r) { return r.json(); }).then(function () { window.location.reload(); });
    });
  });
})();
